<ng-container *transloco="let t; prefix: 'tasks.taskDetail.approveTask.attachDialog'">
  <div class="attachment-dialog-main">
    <div class="attachment-dialog-header">
      <span class="attachment-dialog-title headline-small">{{ t('title') }}</span>
      <button
        matIconButton
        type="button"
        class="attachment-dialog-close"
        [attr.aria-label]="t('close')"
        [mat-dialog-close]="undefined">
        <i class="fa-regular fa-xmark" aria-hidden="true"></i>
      </button>
    </div>

    <div
      class="attachment-dialog-upload-area"
      [class.attachment-dialog-upload-area-loaded]="selectedFiles.length > 0"
      (dragover)="onDragOver($event)"
      (drop)="onDrop($event)">
      @if (selectedFiles.length === 0) {
        <div class="attachment-empty-state">
          <span class="attachment-upload-icon">
            <i class="fa-regular fa-arrow-up-from-bracket" aria-hidden="true"></i>
          </span>

          <span class="body-medium-emphasized">{{ t('drag') }}</span>
          <span class="body-medium">{{ t('or') }}</span>

          <button matButton="outlined" type="button" class="attachment-select-button" (click)="fileInput.click()">
            {{ t('select') }}
          </button>

          <span class="body-small">{{ t('formats') }}</span>
        </div>
      } @else {
        <div class="attachment-loaded-state">
          <div class="attachment-file-list">
            @for (file of selectedFiles; track file; let fileIndex = $index) {
              <div class="attachment-file-card">
                <i class="attachment-file-icon fa-regular fa-file-lines" aria-hidden="true"></i>

                <div class="attachment-file-description">
                  <span class="attachment-file-name body-medium-emphasized">{{ file.name }}</span>
                </div>

                <button matButton type="button" class="attachment-remove-button" (click)="removeFile(fileIndex)">
                  {{ t('remove') }}
                </button>
              </div>
            }
          </div>

          <div class="attachment-additional-file-row">
            <span class="body-small">{{ t('formats') }}</span>
            <button matButton type="button" class="attachment-additional-file-button" (click)="fileInput.click()">
              {{ t('addAnother') }}
            </button>
          </div>
        </div>
      }

      <input
        #fileInput
        class="attachment-file-input"
        type="file"
        multiple
        accept=".pdf,.doc,.docx,.xls,.xlsx"
        (change)="onFileSelected($event)" />
    </div>
  </div>

  <div class="attachment-dialog-footer">
    <div class="attachment-dialog-actions">
      <button matButton type="button" [mat-dialog-close]="undefined">
        {{ t('cancel') }}
      </button>
      <button matButton="filled" type="button" [disabled]="selectedFiles.length === 0" (click)="upload()">
        {{ t('upload') }}
      </button>
    </div>
  </div>
</ng-container>
